import React from "react";
import { FaStar, FaGlobe, FaNetworkWired, FaFlag, FaMobileAlt, FaRobot } from 'react-icons/fa';
import { BsArrowReturnRight } from 'react-icons/bs';
import '../css/gtc-guide.css';

function GTCUsageGuide() {
    return (
        <div className="usage-guide">
            <div className="guide-section">
                <div className="guide-title">
                    <FaStar className="guide-icon" />
                    <span>Wildcard Character</span>
                </div>
                <div className="example-list">
                    <div className="example-item">
                        <BsArrowReturnRight className="example-icon" />
                        <div className="example-content">
                            <span className="example-code">*</span>
                            <span className="example-text">Use asterisk to allow or block all access attempts</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="guide-section">
                <div className="guide-title">
                    <FaGlobe className="guide-icon" />
                    <span>Domain Format</span>
                </div>
                <div className="example-list">
                    <div className="example-item">
                        <BsArrowReturnRight className="example-icon" />
                        <div className="example-content">
                            <span className="example-code">domain.com</span>
                            <span className="example-code">www.domain.com</span>
                            <span className="example-code">subdomain.domain.com</span>
                            <div className="example-text">Controls access for specific domains and their subdomains</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="guide-section">
                <div className="guide-title">
                    <FaNetworkWired className="guide-icon" />
                    <span>IP Address Format</span>
                </div>
                <div className="example-list">
                    <div className="example-item">
                        <BsArrowReturnRight className="example-icon" />
                        <div className="example-content">
                            <div><span className="example-code">89.0.142.86</span> <span className="example-text">IPv4 format</span></div>
                            <div><span className="example-code">2001:0db8:85a3:0000:0000:8a2e:0370:7334</span> <span className="example-text">IPv6 format</span></div>
                            <div><span className="example-code">89.0.142.86/24</span> <span className="example-text">CIDR notation for IP range</span></div>
                            <div><span className="example-code">89.0.142.86 - 89.0.142.255</span> <span className="example-text">IP range format</span></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="guide-section">
                <div className="guide-title">
                    <FaFlag className="guide-icon" />
                    <span>Country Code Format</span>
                </div>
                <div className="example-list">
                    <div className="example-item">
                        <BsArrowReturnRight className="example-icon" />
                        <div className="example-content">
                            <span className="example-code">PH</span>
                            <span className="example-code">US</span>
                            <span className="example-code">SG</span>
                            <div className="example-text">Use two-letter country codes to control access by country</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="guide-section">
                <div className="guide-title">
                    <FaMobileAlt className="guide-icon" />
                    <span>Device Type Format</span>
                </div>
                <div className="example-list">
                    <div className="example-item">
                        <BsArrowReturnRight className="example-icon" />
                        <div className="example-content">
                            <span className="example-code">android</span>
                            <span className="example-code">desktop</span>
                            <span className="example-code">ios</span>
                            <span className="example-code">mobile</span>
                            <span className="example-code">tablet</span>
                            <span className="example-code">smarttv</span>
                            <div className="example-text">Specify device types to control access by device</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="guide-section">
                <div className="guide-title">
                    <FaRobot className="guide-icon" />
                    <span>User Agent Format</span>
                </div>
                <div className="example-list">
                    <div className="example-item">
                        <BsArrowReturnRight className="example-icon" />
                        <div className="example-content">
                            <span className="example-code">Googlebot</span>
                            <div className="example-text">Enter keywords to match against user agent strings</div>
                            <div className="note-text">Example: If you enter "Googlebot", it will match user agents like "Googlebot/2.1 (+http://www.google.com/bot.html)"</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GTCUsageGuide;